import "./Loading.scss";
import logo from "../../assets/logo/logo.png";

const Loading = () => {
  return (
    <div className="loading">
      <img src={logo} alt={"logo"} className="loading__logo" />
      <p className="loading__text">LOADING</p>
    </div>
  );
};

export default Loading;
